export default function (state,getters,rootState, rootGetters) {
    return rootGetters['dictionaries/paymentType/select/list'];
}